import React, { useEffect, useState } from 'react';

const Education = () => {
  const [education, setEducation] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/education.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load education data');
        return res.json();
      })
      .then(setEducation)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <section className="resume-education"><p>Loading...</p></section>;
  if (error) return <section className="resume-education"><p>Error: {error}</p></section>;

  return (
    <section className="resume-education">
      <h2>Education</h2>
      {education.map((edu, idx) => (
        <div className="education-item" key={idx}>
          <h3>{edu.degree}</h3>
          <p>{edu.school}, {edu.year}</p>
        </div>
      ))}
    </section>
  );
};

export default Education;
